/**
 * Configuración de API
 * Desarrollado por Rafael Martinez
 * © 2025
 */

// Determinar la URL de la API basándose en el entorno
const getApiUrl = () => {
  // Si existe una variable de entorno, usarla
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Si estamos en producción (dominio real), usar la URL de Render
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return 'https://creator-agents-backend.onrender.com';
  }

  // Por defecto, desarrollo local
  return 'http://localhost:5000';
};

const API_CONFIG = {
  BASE_URL: getApiUrl(),
  ENDPOINTS: {
    // Suscripciones
    CREATE_SUBSCRIPTION: '/api/subscriptions/create',
    CHECK_EMAIL: '/api/subscriptions/check-email',
    GET_AGENT_STATUS: (id) => `/api/subscriptions/${id}/agent-status`,
    DOWNLOAD_FILE: (id, index) => `/api/subscriptions/${id}/files/${index}/download`,

    // Admin
    ADMIN_LOGIN: '/api/admin/login',
    ADMIN_STATS: '/api/admin/dashboard/stats',
    ADMIN_SUBSCRIPTIONS: '/api/admin/subscriptions',
    ADMIN_SUBSCRIPTION_STATUS: (id) => `/api/admin/subscriptions/${id}/status`,
    ADMIN_DELETE_SUBSCRIPTION: (id) => `/api/admin/subscriptions/${id}`,

    // Scanner
    SCAN_WEBSITE: '/api/scanner/scan-website',

    // Health
    HEALTH_CHECK: '/api/health'
  }
};

// Función helper para construir URLs completas
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

export default API_CONFIG;